import { DropInPaymentsCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { executeDropInPaymentsCommands } from '../../redux/command/command.action';
import { saveConfigs } from '../../redux/config/config.slice';
/**
 * Fires a coupon-related command based on the provided parameters
 */
export var fireCouponCommand = function fireCouponCommand(_ref) {
  var couponCode = _ref.couponCode,
    productFamily = _ref.productFamily,
    cartId = _ref.cartId,
    dispatch = _ref.dispatch,
    isCouponVerified = _ref.isCouponVerified,
    commandType = _ref.commandType;
  if (couponCode && couponCode.length > 0) {
    if (isCouponVerified && commandType === DropInPaymentsCommandNames.ADD_COUPON) {
      // this is a already verified + applied coupon, and no need to add it again to this cart
      // update addCouponStatus prop to success in case of api response error
      dispatch(saveConfigs({
        coupon: {
          addCouponStatus: StatusTypes.SUCCESS,
          removeCouponStatus: '',
          totalWithCurrencyFormat: ''
        }
      }));
    } else {
      // dispatch add or remove coupon command
      dispatch(executeDropInPaymentsCommands([{
        commandName: commandType,
        data: {
          productType: productFamily,
          checkoutFlowType: 'SINGLE_ITEM_PURCHASE',
          couponCode: couponCode,
          cartId: cartId
        }
      }])
      //The typescript compiler is not smart enough to narrow down types here so we have to cast
      );
    }
  }
};

/**
 * Callback function for processing coupon-related data from a payment methods callback
 */
export var callbackFromCoupon = function callbackFromCoupon(_callbackPayload, _dispatch) {
  // do nothing in here for now. DIP is already passing all required data in callbacks
  // callback(callbackPayload, dispatch);
};

/**
 * Retrieves coupon details for Rio
 * @param addCouponStatus
 * @param couponCode
 * @param orderSummary
 * @returns an object representing the coupon details or undefined if conditions are not met
 */
export var getRioCouponDetails = function getRioCouponDetails(addCouponStatus, couponCode, orderSummary) {
  if (couponCode && addCouponStatus === 'SUCCESS' && orderSummary && Object.keys(orderSummary).length) {
    var total = orderSummary.total,
      discount = orderSummary.discount,
      currencyName = orderSummary.currencyName,
      subtotalOriginal = orderSummary.subtotalOriginal;
    return {
      coupon_code: couponCode,
      coupon_discount_amount: discount,
      currency: currencyName,
      offer_amount: total,
      original_price: subtotalOriginal
    };
  }
  return undefined;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/Coupon/helper.js
// module id = 4659
// module chunks = 11